<template>
  <wtFormLeft>
    <!-- SLOT DEFAULT -->
    <template slot="default">
      <b-form class="text-uppercase">
        <!-- Line 01 -->
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="bpm_process_task_bpm_process_task_id">Process ID</label>
            <input
              type="text"
              class="form-control"
              id="bpm_process_task_bpm_process_task_id"
              v-model.trim="objItem.bpm_process_task_id"
            />
          </div>
        </div>

        <!-- Line 02 -->
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="bpm_process_task_description">Process Task</label>
            <input
              type="text"
              class="form-control"
              id="bpm_process_task_description"
              v-model.trim="objItem.process_label"
              @keyup="toUpperCase"
            />
          </div>
        </div>
      </b-form>
    </template>

    <!-- SLOT FOOTER -->
    <template slot="footer">
      <div class="mr-3">
        <b-button id="btnReset" size="sm" pill variant="primary" class="mx2" @click="reset">
          <i class="fa fa-eraser"></i> RESET
        </b-button>
      </div>
      <div class="ml-3">
        <b-button id="btnApply" size="sm" pill variant="primary" @click="apply">
          <i class="fa fa-search"></i> APPLY
        </b-button>
      </div>
    </template>
  </wtFormLeft>
</template>

<script>
/** COMPONENTS - LAYOUT **/
import wtFormLeft from "@/components/forms/wtFormLeft";

export default {
  name: "BpmProcessTaskFilter",
  components: { wtFormLeft },
  data() {
    return {
      /* Objects Page */
      objItem: {},
      objItemData: {},
      nameObjData: "bpm_process_task_data"
    };
  },
  methods: {
    reset() {
      this.objItem = {};
      this.objItemData = {};
      this.$store.commit("setObjFilter", {});
      this.$store.commit("setResetFilter", true);
      this.$store.commit("setApplyFilter", false);
      this.$store.commit("setShowGrid", true);
      this.$store.commit("setAction", "reset");
    },
    apply() {
      const objClone = { ...this.objItem };
      this.$store.commit("setObjFilter", objClone);
      this.$store.commit("setApplyFilter", true);
      this.$store.commit("setResetFilter", false);
    },
    toUpperCase() {
      this.objItem.description = this.objItem.description.toUpperCase();
    }
  },
  updated() {
    this.$store.commit("setApplyFilter", false);
    this.$store.commit("setResetFilter", false);
  }
};
</script>